<div class="main-marketplace">
    <div class="marketplace-container">
        <div class="marketplace-card">
            <!-- Logo Section -->
            <div class="logo-section">
                <div class="logo-icon">
                    <img src="/assets/img/logo-no-bg.png" alt="" />
                </div>
            </div>

            <!-- Content Section -->
            <div class="content-section">
               <h1 class="welcome-title">
                 {{ title }}
             </h1>

                <div class="description">
                    <p>
                        {{ message }}
                    </p>
                </div>
            </div>
           
        </div>
    </div>

</div>